import { createFileRoute } from '@tanstack/react-router';
import Companies from '../../../features/baseData/companies/companies';
import {
  COMPANIES_PERMISSIONS,
  createPermissionGuard,
  getPermissionSet,
} from '@bmwe/ui';

export const Route = createFileRoute('/stammdaten/firmen/')({
  component: Companies,
  beforeLoad: createPermissionGuard(
    getPermissionSet(COMPANIES_PERMISSIONS, 'READ'),
  ),
});

export const ListCompaniesRoute = Route;
